import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a5cd6aec"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "json-xml-container"
};
const _hoisted_2 = {
  class: "button-group"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_input, {
    modelValue: $data.inputData,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.inputData = $event),
    placeholder: "请输入 JSON 或 XML 数据",
    class: "input-area",
    type: "textarea"
  }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
    type: "primary",
    onClick: $options.convertJsonToXml
  }, {
    default: _withCtx(() => [_createTextVNode("转换为 XML")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    type: "success",
    onClick: $options.convertXmlToJson
  }, {
    default: _withCtx(() => [_createTextVNode("转换为 JSON")]),
    _: 1
  }, 8, ["onClick"])]), _createVNode(_component_el_input, {
    modelValue: $data.outputResult,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.outputResult = $event),
    placeholder: "转换后的结果将显示在这里",
    class: "output-area",
    type: "textarea",
    readonly: ""
  }, null, 8, ["modelValue"])]);
}